import bemBlock from "@gik/core/utils/bemBlock";
import type { UIGradient, UISectionDecoration } from "@gik/ui-legacy/types";
import classnames from "classnames";
import type React from "react";

import type { PageSectionProps } from "../PageSection";
import { PageSection } from "../PageSection";

export interface IPageHeaderProps extends PageSectionProps {
	variant?: UIGradient;
	contained?: boolean;
	decoration?: UISectionDecoration;
}

export function PageHeader({
	children,
	decoration,
	className,
	...otherProps
}: React.PropsWithChildren<IPageHeaderProps>): React.ReactElement {
	const bem = bemBlock("page-header");
	const blockClasses = classnames([bem(), className || ""]);

	return (
		<PageSection
			asElement={"header"}
			decoration={decoration}
			className={blockClasses}
			{...otherProps}
		>
			{children}
		</PageSection>
	);
}
